import React, { useState } from 'react';
import './AdminLogin.css';

const AdminDebug: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);

  const check = async () => {
    setError(null);
    setResult(null);
    if (!email || email.trim() === '') {
      setError('Please enter an email to check');
      return;
    }
    setLoading(true);
    try {
      const res = await fetch('/api/check-admin-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim().toLowerCase() })
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data?.error || JSON.stringify(data));
      } else {
        setResult(data);
      }
    } catch (err: any) {
      setError(String(err.message || err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login">
      <div className="login-container">
        <div className="login-header">
          <h1 className="login-title">Admin Debug — Check Email Role</h1>
          <p className="login-description">Enter an email to check whether it has role &quot;admin&quot; in the users table.</p>
        </div>

        <div className="login-form" style={{ padding: 16 }}>
          <div className="form-group">
            <label className="form-label">Email</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} className="form-input" placeholder="admin@yourdomain.com" />
          </div>

          <div style={{ marginTop: 12 }}>
            <button className="login-button" onClick={check} disabled={loading}>{loading ? 'Checking...' : 'Check'}</button>
          </div>

          {error && <div style={{ marginTop: 12, color: '#e53935' }}>{error}</div>}

          {result && (
            <div style={{ marginTop: 12 }}>
              <div><strong>isAdmin:</strong> {String(result.isAdmin)}</div>
              <div style={{ marginTop: 8 }}><strong>user row:</strong></div>
              <pre style={{ whiteSpace: 'pre-wrap', background: '#f6f6f6', padding: 8, borderRadius: 4 }}>{JSON.stringify(result.user, null, 2)}</pre>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminDebug;
